export default __webpack_public_path__ + "static/media/auth.753498d3.svg";